const firstText = (...values) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value != null && typeof value !== 'object') {
      const text = String(value).trim();
      if (text) return text;
    }
  }
  return '';
};

export const getGuaRefUrl = (item) => firstText(item?.url, item?.imageUrl, item?.base64, item?.src);

export const getGuaRefName = (item, fallback = '角色') => (
  firstText(item?.displayName, item?.name, item?.label, item?.title, fallback)
    .replace(/^(人物|角色|场景|地点|道具|物件)[:：]\s*/, '')
);

export const buildGuaVoiceBindings = (imageRefs = []) => {
  // Seedance voice references are retired. Keep the compatibility function
  // while older saved projects and callers are phased out.
  void imageRefs;
  return [];
};

export const applyGuaVoiceBindingPrompt = (prompt, bindings = [], options = {}) => {
  void bindings;
  void options;
  const text = firstText(prompt);
  return text
    .split('\n')
    .filter((line) => (
      !/^\s*(?:[-*#>]\s*)*(音色绑定|voice\s+bindings?)\s*[：:]/i.test(line)
      && !/@(?:音色|Audio)\s*\d+/i.test(line)
    ))
    .join('\n')
    .trim();
};

export const appendGuaVoiceAudioContents = (contents, bindings = []) => {
  void bindings;
  return contents;
};
